const apis = {
  // 使用者信息
  wxUser: '/user',
  // 获取视频用户信息
  user: '/user/{uid}',
  // video 视频信息
  video: '/video',
  // 获取播主数据
  anchor: '/{road}/anchor/{anchorId}',
  // 所有播主信息排序
  allAnchor: '/{road}/anchor',
  // 单个达人视频
  anchorOpus: '/{road}/anchor/{anchorId}/opus',
  hotOpusComments: '/hotOpus/{opusId}/comments',
  // 热门视频列表
  hotOpusList: '/{road}/hotOpus',
  videoRegion: '/region',
  heatMapCode: '/{road}/heatMap/100000',
  getWxCode: '/wechat/qrcode',
  // 抖音实时搜索
  douyinSearch: '/douyin/user',
  // 快手实时搜索
  gifshowSearch: '/gifshow/user',
  // 收藏的人物
  anchorCollection: '/anchorCollection',
  // 搜索页面没有关键词时候的展示
  searchRecommend: '/gifshow/anchor/recommend',
  // 获取快手id
  gifUser: '/gifshow/user/{userId}',
  getWxShareCode: '/gifshow/anchor/{anchorId}/qrCode',
  someDaysNumChange: '/{road}/anchor/{anchorId}/history',
  // 作品时长分析
  opusDuration: '/gifshow/anchor/{anchorId}/statistic/opusDuration',
  // pdf输出报告
  reportPage: '/gifshow/anchor/{userId}/report',
  // 电商分析数据
  ecommerce: '/{road}/anchor/{anchorId}/ecommerce',
  // 直播分析
  liveAnalysis: '/{road}/anchor/{anchorId}/liveAnalysis',
  // jvti mouyichang de zhibo
  liveAnalysisDetail: '/gifshow/anchor/{anchorId}/liveAnalysis/{liveAnalysisId}',
  // 作品发布时间
  opusPublish: '/{road}/anchor/{anchorId}/statistic/opusPublish',
  // 查询已开通套餐
  businessPackage: '/businessPackage',
  // jiage
  businessPackageScene: '/businessPackageScene',
  // 获取用户开通的账单详情
  businessOrder: '/businessOrder',
  businessNotice: '/businessNotice',
  // 订阅/收藏 列表
  liveStream: '/gifshow/liveStream',
  // 礼物收入榜
  liveStreamGift: '/{road}/liveStreamGift',
  // 直播带货榜
  liveStreamECommerce: '/gifshow/liveStreamECommerce',
  // 热销商品榜
  liveStreamBestSellers: '/{road}/liveStreamBestSellers',
  // 土豪送礼
  liveStreamTycoon: '/{road}/liveStreamTycoon',
  // 直播人气榜单
  liveStreamPopularity: '/{road}/liveStreamPopularity',
  // 带货分类
  category: '/category',
  // 商品详情页销量趋势
  salesTrend: '/{road}/commodity/{id}/salesTrend',
  // 达人关联商品销量
  anchorSales: '/{road}/commodity/{id}/anchorSales',
  // 达人关联直播
  shopLiveStream: '/{road}/commodity/{id}/liveStream',
  // 商品信息
  commodityInfo: '/{road}/commodity/{id}',
  // 周直播带货榜单
  liveStreamBestSales: '/{road}/liveStreamBestSales',
  // 公开活动
  anchorEvents: '/{road}/anchorEvents',
  // 获取搜索热词
  hotKeyWord: '/hotKeyWord',
  // 收藏数量匹配
  userInterests: '/userInterests',
  //直播日历 按 日 选择
  liveCalendar: '/{road}/anchor/{anchorId}/liveCalendar',
  // 直播日历多场直播销售汇总
  liveStreamsSales: '/{road}/anchor/{anchorId}/liveStreamsSales',
  // 直播日历多场直播礼物汇总
  liveStreamsGifts: '/{road}/anchor/{anchorId}/liveStreamsGifts',
  // 获取主播直播礼物收支信息
  liveStreamsGiftGiving: '/{road}/anchor/{anchorId}/gift',
  // 礼物送出
  giftGive: '/gifshow/anchor/{anchorId}/liveStreamLog/{liveAnalysisId}/gift',
  // 单场礼物统计数据
  singleLiveStreamStatistic: '/{road}/singleLiveStreamStatistic',
  // 首页搜索 商品推荐
  commodityRecommend: '/{road}/commodity/recommend',
  anchorShopInfo: '/{road}/anchor/{anchorId}/shop',
  // 获取主播直播礼物收支信息
  getGiftMode: '/{road}/anchor/{anchorId}/gift',
  // 获取直播礼物收入送出统计数据
  liveStreamStatistic: '/{road}/anchor/{anchorId}/liveStreamStatistic',
  // 商品7天信息统计
  goodsStatic: '/{road}/commodity/{id}/liveStreamStatistic',
  // 监控的人每天直播信息
  subscriptionList: '/gifshow/liveStream/subscriptionList',
  // h5支付加参数
  paymentScene: '/paymentScene',
  // wxconfig
  getWxConfig: '/wechat/accessToken/wxc3c24b5b6b23c158',
  // 免费页面
  freeAnchor: '/{road}/freeAnchor',
  verifyCode: '/verifyCode',
  // 手机号登录
  mobileLogin: '/user/session',
  wechatBindMobile: '/wechat/mobile',
  //  挂榜主播
  trafficAnchor: '/{road}/trafficAnchor',
  // 主播最近7场主播
  diversion: '/{road}/anchor/{anchorId}/diversion',
  // 主播该场直播挂榜的人
  anchorLiveDiversion: '/{road}/anchor/{anchorId}/diversion/{diversionId}',
  // 查询订单支付状态
  businessOrderOrderNo: '/businessOrder/{orderNo}',
  // pk 详情
  pkDrainage: '/{road}/anchor/{anchorId}/pkDrainage/{pkDrainageId}',
  // 直播人气
  livePopularity: '/{road}/anchor/{anchorId}/popularity',
  qiniuToken: '/qiniuUploadToken',
  // 红人好货添加商品
  operationsEvents: '/operationsEvents/{operationsEventsId}',
  // 报名分销
  operationsEventsCheckIn: '/operationsEvents/{id}/checkIn',
  // 分销钱包信息
  courseWallet: '/wallet',
  // 分销信息
  courseEventsDistribution: '/eventsDistribution',
  miniProgramShare: '/link',
  // hongbang
  battle: '/battle',
  // 品牌热销榜
  brandOverall: '/brandSales/brandOverall',
  brandDetail: '/brandSales/{brandId}',
  // 获取品牌销售趋势
  brandSalesTrends: '/brandSales/{brandId}/brandSalesTrends',
  // 获取品牌关联商品列表
  brandCommodity: '/brandSales/{brandId}/brandCommodity',
  // 获取品牌关达人
  brandAnchor: '/brandSales/{brandId}/brandAnchor',
  // 获取品牌关联直播列表
  brandStream: '/brandSales/{brandId}/brandStream',
  // 小程序审核状态
  addOnConfigure: '/addOnConfigure/{appId}',
  // 品牌查找
  brandSearch: '/brandSales/brand',
  // 省市下拉框内容
  region: '/region',
  // 各项统计数据，如首页已为XXX场直播提供服务
  statistic: '/statistic',
  shareSwitch: '/shareSwitch',
  userInfo: '/userInfo',
  shopBestSales: '/shopBestSales',
  brandStatistic:'/brandStatistic', // 品牌排行榜数据
  typeGroup:'/type/group', // 获取服务方向类目
  submitService:'/user/info', // 提交表单
  postForm:'/user/business', // 提交表单new
  trialBusinessPackage:'/trialBusinessPackage', // 领取试用会员
  sortLink: '/wechat/urlLink',
  sellOpusStatistic: '/sellOpusStatistic',//带货视频榜
  opus: '/opus',//视频库
  addFans:'/anchor/fansIncreaseStatistic',//达人涨粉榜
  liveFlow:'/liveStream/uvStatistic',//直播流量榜
  liveTime:'/anchor/liveDurationStatistic',//直播时长榜
  anchorData:'/anchor/{anchorId}/statistic',
  favorites:'/{road}/favorites',//关注  取消
  opusStatistic:'/anchor/{anchorId}/opusStatistic',
  opusCommodity:'/anchor/{anchorId}/opusCommodity',
  opusDateStatistic:'/anchor/{anchorId}/opusDateStatistic',//视频发布日历
  opusHeatStatistic:'/anchor/{anchorId}/opusHeatStatistic',//视频热度日历
  opusAnchor:'/gifshow/anchor/{anchorId}/opus',
  hotAnchorRank:'/hotAnchorRank',//短剧达人榜
  hotTopicRank:'/hotTopicRank',//快手话题榜
  hotOpusRank:'/hotOpusRank',//视频传播/互动榜,
  userFavorites: '/userFavorites',//关注
  statisticShop:'/shop/{shopId}/statistic',//店铺数据,
  statisticBrand:'/brand/{brandId}/statistic'
};
export default apis;
